import { render } from "./view-small-event.vue?vue&type=template&id=6b818cf5&scoped=true&lang=html"
import script from "./view-small-event.vue?vue&type=script&lang=js"
export * from "./view-small-event.vue?vue&type=script&lang=js"

import "./view-small-event.vue?vue&type=style&index=0&id=6b818cf5&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b818cf5"]])

export default __exports__